import { UIIcon } from '../config/icons';
import { ABFilterBar } from '../lib/ab/filter-bar';
import { ABCountrySelect, ABLanguageSelect, ABPlanSelect } from '../lib/ab/select-admin';
import { ABObjectCount } from '../lib/ab/widgets-admin';
import { PGiftcard, PGiftcardAdminView, pGiftcardDelivered, pGiftcardGetTransactions, pGiftcardsGenerate, pGiftcardsGetAll, pGiftcardUpdate, pGiftcardVoid } from '../lib/mdl/p-giftcard';
import { the_alt_token } from '../lib/me/login';
import { UIButton } from '../lib/ui/component/button';
import { UIDialog } from '../lib/ui/component/dialog';
import { UINumberInput, UITextInput } from '../lib/ui/component/input';
import { UITable, UITableDefinition } from '../lib/ui/component/table';
import { uiToast } from '../lib/ui/component/toast';
import { $el } from '../lib/ui/elements';
import { $fmt } from '../lib/ui/fmt';
import { UIScreen } from '../lib/ui/screen';
import { UIValue } from '../lib/ui/types';
import { UIViewSpec } from '../lib/ui/view';
import { YArrayDataSource } from '../lib/y/data-source';
import { $log, xavis_experiments } from '../lib/y/debug';
import { $on } from '../lib/y/events';
import { $form } from '../lib/y/form';
import { $location } from '../lib/y/location';
import { $time } from '../lib/y/time';
import { YCountryId } from '../lib/y/types';

class GenerateDialog extends UIDialog {
    constructor(vip: boolean) {
        super({ close: true, classes: 'm-500' });

        $log('app', 'it\'s new dialog!');

        const kind = new ABPlanSelect({ required: true });
        kind.value = 'standard';
        const country = new ABCountrySelect({ required: true });
        country.value = 'SE';
        const language = new ABLanguageSelect({ required: true });
        language.value = 'sv';

        const months = new UINumberInput({ placeholder: 'Months', required: true, min: 1, max: 12 });
        const quantity = new UINumberInput({ placeholder: 'Quantity', required: true });
        const batch = new UITextInput({ placeholder: 'Batch name', required: true });
        const influencer = new UITextInput({ placeholder: 'Influencer name', required: true });

        const form = $form({ months, kind, country, language });
        if(vip) {
            form.add({ influencer });
        } else {
            form.add({ quantity, batch })
        }

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', vip ? 'Make VIP card' : 'Make batch'),
            $el.P('info', 'Choose options'),
            months,
            kind,
            country,
            language,
            vip && influencer,
            !vip && quantity,
            !vip && batch,
            $el.DIV('l-button-row', new UIButton({
                title: "Update", classes: 'm-round m-compact', on_click: () => {
                    if(!form.validate()) return;
                    return pGiftcardsGenerate(form.value).then(() => {
                        this.dismiss(true);
                    }, uiToast);
                }
            }))
        ]));
    }
}

class EditDialog extends UIDialog {
    constructor(gc: PGiftcard, transactions: any) {
        super({ close: true, classes: 'm-500' });

        $log('app', 'it\'s new dialog!');

        const country = new ABCountrySelect({ required: true });
        const language = new ABLanguageSelect({ required: true });

        const form = $form({ country, language });
        form.value = gc;

        let buy_transaction: string | undefined;

        for(const t of transactions) {
            if(t.kind == 'buy_giftcard' && t.payments.length) {
                buy_transaction = t.payments[0].provider_id ?? '';
                break;
            }
        }

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', 'Edit gift card'),
            $el.P('info', gc.code),
            buy_transaction && $el.P('info', 'Purchase transaction: ' + buy_transaction),
            country,
            language,
            $el.DIV('l-button-row', new UIButton({
                title: "Generate", classes: 'm-round m-compact', on_click: () => {
                    if(!form.validate()) return;
                    return pGiftcardUpdate(gc.id, form.value).then(new_gc => {
                        Object.assign(gc, new_gc);
                        this.dismiss(true);
                    }, uiToast);
                }
            }))
        ]));
    }
}

class DownloadBatchDialog extends UIDialog {
    constructor() {
        super({ close: true, classes: 'm-500' });
        const content = this.content;

        const batch = new UITextInput({ placeholder: 'Batch name', required: true });
        const download = new UIButton({ title: "Download", classes: 'm-round m-compact', link: '' });

        $on(batch, 'value', batch => {
            download.link = '/docs/giftcards/batch/' + batch + '?token=' + the_alt_token;
        });

        content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', 'Download batch'),
            batch,
            $el.DIV('l-button-row', download)
        ]));
    }
}

function getDeliveryInfo(gc: PGiftcard) {
    if(gc.batch)
        return 'Batch (' + gc.batch + ')';
    else if(gc.influencer)
        return 'Influencer (' + gc.influencer + ')';
    else if(gc.delivery_address?.name)
        return 'Post';
    else
        return 'Email';
}

export class AdminGiftcardsScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        const doSearch = () => {
            let giftcards = filter_bar.search_input!.filterArray(all_giftcards, (c, w) => {
                if(c.buyer_name.toLowerCase().includes(w)) return true;
                if(c.buyer_email.toLowerCase().includes(w)) return true;
                if(c.code.toLowerCase().includes(w)) return true;
                if(c.plan.toLowerCase().includes(w)) return true;
                return false;
            });

            const filter_value = filters.value;
            if(filter_value.country)
                giftcards = giftcards.filter(b => b.country == filter_value.country);
            if(filter_value.post_only)
                giftcards = giftcards.filter(b => getDeliveryInfo(b) == 'Post');

            giftcards.sort((a, b) => a.created_at < b.created_at ? 1 : -1);

            count.number = giftcards.length;
            source.data = giftcards;
        }

        const count = new ABObjectCount('cards');

        const filter_bar = new ABFilterBar({
            on_search: doSearch,
            on_filter: doSearch,
            right_content: [
                new UIButton({
                    kind: 'k-filter', icon: UIIcon.DOWNLOAD, title: 'Batch', on_click: () => {
                        new DownloadBatchDialog().present()
                    }
                }),
                new UIButton({
                    kind: 'k-filter', icon: UIIcon.PLUS, title: 'Batch', on_click: () => {
                        new GenerateDialog(false).present().then(() => { $location.reload() });
                    }
                }),
                new UIButton({
                    kind: 'k-filter', icon: UIIcon.PLUS, title: 'VIP', on_click: () => {
                        new GenerateDialog(true).present().then(() => { $location.reload() });
                    }
                }),
                xavis_experiments && new UIButton({ kind: 'k-filter', icon: UIIcon.DOWNLOAD, title: 'Example', link: '/docs/giftcard/example' }),
                count
            ],
            no_header: true
        });

        const filters = filter_bar.filters;
        const country_values: UIValue<YCountryId>[] = [{ key: 'SE', name: 'Sweden' }, { key: 'DE', name: 'Germany' }];
        filters.addSelect('country', 'Country', country_values, 'All countries');
        filters.addCheckbox('post_only', 'Post only');

        const def = new UITableDefinition<PGiftcardAdminView>();
        def.addValue(c => c.buyer_name, { title: 'Buyer name', width: 100 });
        def.addValue(c => c.buyer_email, { title: 'Buyer email', width: 100 });
        def.addValue(c => c.country, { title: 'Country', width: -90 });
        def.addValue(c => getDeliveryInfo(c), { title: 'Delivery', width: -160 });
        def.addValue(c => c.code, { title: 'Code', width: -100 });
        def.addValue(c => c.plan, { title: 'Plan', width: -100 });
        def.addValue(c => c.months, $fmt.NUMBER, { title: 'Months', width: -80 });
        def.addValue(c => $time(c.created_at), $fmt.DATE('d MMM yyyy HH:mm'), { title: 'Purchase date', width: -140 });
        def.addValue(c => c.redeem_user_email ?? '-', { title: 'Redeemed by', width: 100 });
        const token = the_alt_token;
        def.addButtons([
            {
                icon: UIIcon.TRASH_CAN, tooltip: 'Void', when: g => !g.is_redeemed && !g.is_voided, action: (g, row) => {
                    pGiftcardVoid(g.id).then(() => {
                        g.is_voided = true;
                        row.reload();
                    });
                }
            },
            {
                icon: UIIcon.PENCIL, tooltip: 'Edit', action: (g, row) => {
                    pGiftcardGetTransactions(g.id).then(transactions => {
                        new EditDialog(g, transactions).present().then(() => { row.reload() });
                    });
                }
            },
            {
                icon: UIIcon.PAPER_PLANE, tooltip: 'Mark delivered', classes: g => g.is_delivered ? 'f-green' : '', when: g => !!g.delivery_address?.name, action: (g, row) => {
                    pGiftcardDelivered(g.id).then(() => {
                        g.is_delivered = true;
                        row.reload();
                    });
                }
            },
            {
                icon: UIIcon.PAPERCLIP, tooltip: 'Kvitto', //TODOURGENT: when: b => $id.isValidObjectId(b.payment_transaction),
                link: b => ({
                    href: '/docs/giftcard/' + b.id + '/receipt?format=pdf&token=' + token,
                    download: 'Abundo kvitto - ' + $time(b.created_at).format('yyyy-MM-dd') + '.pdf'
                })
            },
            { icon: UIIcon.DOWNLOAD, tooltip: 'Download', link: b => '/docs/giftcard/' + b.id + '?token=' + token }
        ], { width: -150 });

        def.controller = row => {
            if(row.item.is_voided)
                row.classList.add('tl-canceled-row');

            return {
                expand: () => {
                    const address = row.item.delivery_address;
                    const text = row.item.texts;
                    const exp = $el.DIV('tl-inner-table');

                    if(text) {
                        exp.ui_add([
                            $el.B('From: ' + text.from),
                            $el.B('To: ' + text.to)
                        ]);
                    }

                    if(address) {
                        exp.ui_add([
                            $el.B(address.name),
                            $el.B(address.address),
                            $el.B(address.post_code + ' ' + address.city)
                        ]);
                    }

                    return exp;
                }
            }
        }

        def.preference_prefix = 'giftcards';

        const source = new YArrayDataSource<PGiftcard>();
        const table = new UITable(def, source, { progressive: true });
        table.on_row_selected = (r) => {
            if(r.item.delivery_address?.name)
                r.expand(true);
        }

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block m-wider', [
                filter_bar,
                table,
            ])),
        ]);

        let all_giftcards = await pGiftcardsGetAll(); //$p.getGiftcardAdminView();
        doSearch();
    }
}